import { useBreakpointValue } from 'native-base'

import { PREMIO_PLUS_URL, UsePremioPlusScreen } from './PremioPlusScreen.types'

export const usePremioPlusScreen: UsePremioPlusScreen = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  return {
    isMobile,
    url: PREMIO_PLUS_URL
  }
}
